module.exports = __webpack_public_path__ + "static/img/pay_fail_vava.aa78fa1e.png";